import styled from "styled-components"

import { Box } from "components/common"

const SectionList = styled(Box).attrs((props) => ({
  as: "ul",
  color: "neutral",
  fontSize: { _: 14, tablet: 16 },
  fontWeight: 300,
  lineHeight: { _: "1.65", tablet: "18px" },
  mb: 2,
  pl: "20px",
  ...props,
}))``

export default SectionList
